import React, { useEffect, useRef, useState } from 'react';

const Numeros = () => {
  const stats = [
    { label: "Anos de mercado", value: "+20" },
    { label: "Máquinas Desenvolvidas", value: "+15" },
    { label: "Clientes Ativos", value: "+100" },
  ];

  const parsed = stats.map((s) => {
    const hasPlus = s.value.includes("+");
    const digitsOnly = s.value.replace(/[^0-9]/g, ""); 
    const target = parseInt(digitsOnly || "0", 10);
    return { target, prefix: hasPlus ? "+" : "" };
  });

  const [values, setValues] = useState(() => parsed.map(() => 0));
  const rafRef = useRef(null);
  const startRef = useRef(null);
  const statsRef = useRef(null);
  const [hasAnimated, setHasAnimated] = useState(false);
  const duration = 2400; // ms

  useEffect(() => {
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, []);

  const format = (n) => {
    try {
      return new Intl.NumberFormat("pt-BR").format(n);
    } catch {
      return String(n);
    }
  };

  const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

  const startCount = () => {
    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    startRef.current = null;

    const step = (timestamp) => {
      if (!startRef.current) startRef.current = timestamp;
      const elapsed = timestamp - startRef.current;
      const progress = Math.min(elapsed / duration, 1);
      const eased = easeOutCubic(progress);

      const next = parsed.map((p) => Math.round(p.target * eased));
      setValues(next);

      if (progress < 1) {
        rafRef.current = requestAnimationFrame(step);
      } else {
        rafRef.current = null;
      }
    };

    rafRef.current = requestAnimationFrame(step);
  };

  useEffect(() => {
    const el = statsRef.current;
    if (!el || typeof IntersectionObserver === "undefined") return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated) {
            setHasAnimated(true);
            startCount();
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(el);

    return () => {
      if (el) observer.disconnect();
    }
  }, [hasAnimated]);

  return (
    <section className="bg-usifresa-dark py-24 md:py-32 text-white overflow-hidden relative">
      {/* Background simplificado sem gradientes artificiais */}
      <div className="absolute inset-0 bg-usifresa-dark/95 z-0"></div>
      
      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24 items-center">
          
          {/* Lado Esquerdo */}
          <div className="w-full lg:w-5/12">
            <h2 className="font-sans text-4xl md:text-5xl lg:text-6xl text-white font-black mb-6 leading-[1.1] tracking-tight uppercase">
              Impacto que <br /> gera resultados
            </h2>
            
            {/* LINHA LARANJA ATUALIZADA */}
            <div className="h-1.5 bg-usifresa-orange mb-8 w-full rounded-full"></div>
            
            <p className="text-lg text-white/70 leading-relaxed font-light">
              Nossa trajetória é construída com <strong className="text-white font-bold">confiança, qualidade e engenharia de ponta</strong>. Esses números refletem o compromisso diário de entregar as melhores soluções em máquinas industriais.
            </p>
          </div>

          {/* Lado Direito - Contadores Reformulados */}
          <div className="w-full lg:w-7/12" ref={statsRef}>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-12 sm:gap-6 lg:gap-10">
              
              {stats.map((stat, index) => (
                <div key={index} className="flex flex-col relative group">
                  {/* Linha decorativa superior que reage ao hover */}
                  <div className="w-12 h-1 bg-usifresa-orange/30 mb-5 transition-all duration-500 ease-out group-hover:w-full group-hover:bg-usifresa-orange"></div>
                  
                  {/* Número Gigante Tipográfico */}
                  <div className="font-title text-6xl md:text-7xl lg:text-[5.5rem] mb-2 text-white font-black tracking-tighter flex items-baseline leading-none drop-shadow-lg">
                    <span className="text-usifresa-orange mr-1 font-light">{parsed[index].prefix}</span>
                    {format(values[index])}
                  </div>
                  
                  {/* Label Simples e Elegante */}
                  <p className="text-sm md:text-xs lg:text-sm font-bold text-white/50 uppercase tracking-[0.2em] leading-relaxed mt-2 group-hover:text-white/80 transition-colors duration-300">
                    {stat.label}
                  </p>
                </div>
              ))}
              
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default Numeros;